module.exports = __webpack_public_path__ + "0c223315de953f0bb173a09aea26441f.pdf";